module.exports = __webpack_public_path__ + "img/proficient_and_efficient.949aa6da.png";